import { withAuthGuard } from '@dark-portal/frontend-identity';
import { del, get, patch, post, RequestResponse } from '@dark-portal/react-infrastructure';

import { ENV } from '@/src/.env';

function url(path: string): string {
  return `${ENV.API_URL}/${path}`;
}

export const Requester = {
  get<TParams = undefined, TResult = void>(path: string, params?: TParams): RequestResponse<TResult> {
    return withAuthGuard(get<TParams, TResult>)({ url: url(path), params });
  },

  post<TBody = undefined, TResult = void>(path: string, body?: TBody): RequestResponse<TResult> {
    return withAuthGuard(post<TBody, TResult>)({ url: url(path), body });
  },

  patch<TBody = undefined, TResult = void>(path: string, body?: TBody): RequestResponse<TResult> {
    return withAuthGuard(patch<TBody, TResult>)({ url: url(path), body });
  },

  del<TResult = void>(path: string): RequestResponse<TResult> {
    return withAuthGuard(del<undefined, TResult>)({ url: url(path) });
  },
};
